import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconLogoBlock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 41,
	height: 41,
	fill: "none",
	viewBox: "0 0 41 41",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 29,
				height: 29,
				x: 6,
				y: 4,
				fill: "#fff",
				rx: 4
			}), /* @__PURE__ */ _jsx("rect", {
				width: 28,
				height: 28,
				x: 6.5,
				y: 4.5,
				stroke: "#F5F5F5",
				rx: 3.5
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00D8FF",
			d: "M24.404 10.527c-1.748.36-6.824 1.373-7.78 1.569-.1.033-.165.098-.165.196v7.91s6.461-7.42 8.142-9.348c.1-.13-.033-.36-.197-.327z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#197FDB",
			d: "M16.525 20.921l4.945-5.687v10.46c0 .195-.231.26-.363.13-1.055-1.079-4.087-4.25-4.582-4.772-.066-.033-.066-.098 0-.13z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd",
			width: 41,
			height: 41,
			x: 0,
			y: 0,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.160784 0 0 0 0 0.164706 0 0 0 0 0.168627 0 0 0 0.08 0" }),
				/* @__PURE__ */ _jsx("feBlend", {
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feColorMatrix", { values: "0 0 0 0 0.160784 0 0 0 0 0.164706 0 0 0 0 0.168627 0 0 0 0.04 0" }),
				/* @__PURE__ */ _jsx("feBlend", {
					in2: "effect1_dropShadow",
					result: "effect2_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "effect2_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgIconLogoBlock;
